// extracted by mini-css-extract-plugin
module.exports = {"mainHeading":"style_mainHeading__gqZZC","heading":"style_heading__4ksCh","row":"style_row__eXmHl"};